<template>
  <div class="box-item">
    <div class="box">
      <div class="text">
        <span>
          {{ $dataCheck(item.title) }}
          <span v-if="item.currency">({{ item.currency }})</span>
        </span>
      </div>
      <div class="number font-manrope">
        {{ $dataCheck(item.count, 0) }}
      </div>
      <div class="rate">
        <span class="font-manrope" :style="item.rate < 0 ? 'color: #00ce47' : ''">{{ $dataCheck(item.rate) }}%</span>
        <i
          class="iconfont iconChevron-Top"
          :style="item.rate < 0 ? 'transform: rotate(180deg);color: #00ce47' : ''"
        ></i>
      </div>
    </div>
    <div class="box-img" v-if="item.icon">
      <i class="iconfont" :class="item.icon"></i>
    </div>
    <slot name="icon"></slot>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
}
</script>

<style lang="scss" scoped>
.box-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  background: #fff;
  height: 130px;
  box-sizing: border-box;
  .text {
    line-height: 1;
    font-size: 12px;
    color: #8a909d;
  }
  .number {
    font-size: 22px;
    line-height: 1;
    font-weight: bold;
    color: #010517;
    margin: 12px 0 19px;
  }
  .rate {
    line-height: 1;
    color: #f23e55;
    font-size: 14px;
    display: flex;
    align-items: center;
    font-weight: bold;
    .iconChevron-Top {
      margin-left: 5px;
      line-height: 14px;
      font-size: 20px;
      font-weight: bold;
      color: #f23e55;
    }
  }
}
.box-img {
  width: 58px;
  height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ecf2ff;
  border-radius: 50%;
  img {
    width: 30px;
    height: 30px;
  }
  .iconfont {
    font-size: 30px;
    color: #0560fd;
  }
}
</style>
